// extracted by mini-css-extract-plugin
module.exports = {"ToggleInput":"Toggle_ToggleInput__ZafMC"};